import { put, takeLatest } from 'redux-saga/effects';

import {
  GET_ACTIVE_BUSINESSES,
  GET_ACTIVE_BUSINESSES_SUCCESS,
  SET_BUSINESS,
} from '../types/business';

import { requestBusinesses } from '../requests/product';
import { onFailRequest } from '@/utils';

/**
 * Get businesses
 * @param payload
 */
function* getActiveBusinesses(payload) {
  try {
    const { params } = payload;
    const { data, metadata } = yield requestBusinesses({ params });

    yield put({
      type: GET_ACTIVE_BUSINESSES_SUCCESS,
      data,
      metadata,
    });
    yield put({
      type: SET_BUSINESS,
      business: data[0],
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
    });
  }
}

export default [takeLatest(GET_ACTIVE_BUSINESSES, getActiveBusinesses)];
